<h2 class="modal-header">
  @if (isDebugModeOn()) {
    <span>
      {{ data.title }}
      @if (data.path) {
        <p>Path: {{ data.path }}</p>
      }
    </span>
  } @else {
  Błąd
}
</h2>
<div class="modal-body">
  <b [innerHTML]="data.message | breakLines"></b>
  @if (data.stacktrace && isDebugModeOn()) {
    <pre>{{ data.stacktrace }}</pre>
  }
</div>
<div class="modal-footer">
  <button class="btn btn-outline-primary" (click)="dialogRef.close()">Ok</button>
</div>
